export default __webpack_public_path__ + "a40219a42efd46e691f9a4784f3d4225.svg";